const EARN_UP_TO_PREFIX = 'Earn up to ';

export const CREDIT_REPURCHASE_LOOP_COPY = {
  pdpSummaryPrefix: EARN_UP_TO_PREFIX,
  pdpSummarySuffix: ' in credits',
  pdpSummary: (amount: string) =>
    `${CREDIT_REPURCHASE_LOOP_COPY.pdpSummaryPrefix}${amount}${CREDIT_REPURCHASE_LOOP_COPY.pdpSummarySuffix}`,
  pdpMembersOnlySuffix: ' (Members Only)',
  pdpShipsGroupLabel: 'After your order ships',
  pdpBaseCreditLabel: (creditRatePercentage: number) => `Base Credit (${creditRatePercentage}%)`,
  pdpBonusCreditLabel: 'Bonus Credit',
  pdpReviewGroupLabel: 'After you write a photo or video review',
  pdpReviewCreditLabel: 'Review Credit',
  pdpTotalLabel: 'Total',
  orderEarnPrefix: EARN_UP_TO_PREFIX,
  orderEarnSuffix: ' in credits with this order.',
  orderEarnLine: (amount: string) =>
    `${CREDIT_REPURCHASE_LOOP_COPY.orderEarnPrefix}${amount}${CREDIT_REPURCHASE_LOOP_COPY.orderEarnSuffix}`,
} as const;
